<template>
  <svg
    class="border border-solid border-grey-300 rounded-full"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect
      x="0.5"
      y="0.5"
      width="63"
      height="63"
      rx="31.5"
      fill="url(#placeholder-photo)"
      stroke="#DEDFE3"
    />
    <defs>
      <pattern
        id="placeholder-photo"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlink:href="#image0_5559_6977"
          transform="scale(0.0138889)"
        />
      </pattern>
      <image
        id="image0_5559_6977"
        width="72"
        height="72"
        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACeUlEQVR4Ae2ai27CMAxF+f+P3As2xnh0jNcYQ5nupEjdldK0TRwou5FQ66ZN7YPtGIvR3f3Y6RNmMBKcMBywEaBIBAmQADWHUCzFyIPkQfIg0zJFIaYQU4gpxGJbseW8cpBy0IBz0OT51a2qtTscPt3p9O38wDmuYQ73WIZQbO2LhNjL9O0XgAcSOwIWnokZYzFfHNBms4vxCM7jWQsITWsWA/TwOHHH41fQ+LYT8Cas1WRUzrligHLA8RABKSeEprWKAEoJKw+Fj6XCzRwQkqvVKJG4zQEhHKxGiVAzBYQaxnpY10mmgKpqbc3HLZaVacI2BWQZXp68dZiZAqr/fPAG5T6ifGjaplPnTAHlhhFaLxVC0/MCdMl2h0IsQl9JOgJI23wEkArFCCDsDpZhZl0DQX/TXQwv0I/VFl6kdkcLSGqYRSCp5RoB5Mv5lHAr1UX0uhZJ0vWX+XMk7i67G+4t0T30+tWP5rtY/WV8jjoJxSQA1HMUznENvR7rhhjrxPJFAbEy1ygLUCR3CpAADfjfHdeYc1gnhViJEHsaT91y+e62u/2f7TrUQ7a6jvIAOkAX6MTe0EdO8iAo8bHZWtmbvC50SwXVG9BstnDn8znZCOsFoCN07eM9eKYXoPl8ZW1X9vWhcx9InQHh2xjq6ONJnQAhnocQVqEvELp3zUmdAF1zQg5B4euwoUuotQYE8rcyunhRa0CoLW5lwJa2XtQa0G63vxU+DrZkB1RvaA2dFGzJDmjoUFh/AWIiJAsQAWFRgJgIyQJEQFgUICZCsgAREBYFiImQLEAEhEUBYiIkCxABYVGAmAjJAkRAWBQgJkJydkD/td3xAzue7Lv3f5gdAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'PlaceholderPhoto',
};
</script>

<style lang="scss" scoped>

</style>
